export const heroStats = [
  { label: 'Total Area', value: '90', suffix: 'Acres' },
  { label: 'Total Plots', value: '1100+', suffix: '' },
  { label: 'Plot Sizes', value: '1200 – 4220', suffix: 'Sqft' },
  { label: 'Community', value: 'Gated', suffix: '' },
];

export const projectOverviewCards = [
  {
    title: '90 Acres Township',
    description: 'Sprawling green landscape with planned infrastructure across 90 acres of premium plots near Bangalore.',
    icon: 'ri-map-2-line',
  },
  {
    title: '1100+ Premium Plots',
    description: 'Meticulously planned plots designed for modern living and investment in a plotted development Bangalore corridor.',
    icon: 'ri-building-line',
  },
  {
    title: '1200 to 4220 Sqft',
    description: 'Flexible plot sizes to suit every budget and vision for land investment near Bangalore.',
    icon: 'ri-ruler-line',
  },
  {
    title: 'Secure Gated Community',
    description: '24/7 security with controlled access for peace of mind in this gated community plots in Malur.',
    icon: 'ri-shield-check-line',
  },
];

export const investMalurFeatures = [
  {
    title: 'Rapid Infrastructure Growth',
    description: 'Road widening, metro plans, and industrial corridor development are transforming Malur into a prime destination for villa plots in Malur and land investment near Bangalore.',
    icon: 'ri-road-map-line',
    stat: '45%',
    statLabel: 'Value Growth YoY',
  },
  {
    title: 'Bangalore Connectivity',
    description: 'Direct access via Old Madras Road and NH-75. Reach Bangalore CBD in just 45 minutes from your investment plots near Bangalore.',
    icon: 'ri-exchange-line',
    stat: '45 min',
    statLabel: 'To Bangalore CBD',
  },
  {
    title: 'Strong Appreciation',
    description: 'Consistent year-over-year value growth makes Malur one of the most promising belts for premium plots near Bangalore and plotted development Bangalore.',
    icon: 'ri-line-chart-line',
    stat: '12%',
    statLabel: 'Avg Annual Return',
  },
  {
    title: 'Emerging Hotspot',
    description: 'Recognized by analysts as the next big growth corridor with major commercial launches underway for gated community plots in Malur.',
    icon: 'ri-fire-line',
    stat: '25+',
    statLabel: 'New Projects',
  },
];

export const amenitiesList = [
  { name: 'Clubhouse', icon: 'ri-community-line' },
  { name: "Children's Play Area", icon: 'ri-bear-smile-line' },
  { name: 'Parks', icon: 'ri-tree-line' },
  { name: 'Landscape Gardens', icon: 'ri-flower-line' },
  { name: 'Wide Internal Roads', icon: 'ri-signpost-line' },
  { name: 'Gated Security', icon: 'ri-shield-check-line' },
  { name: 'Green Spaces', icon: 'ri-sun-line' },
  { name: 'Community Areas', icon: 'ri-group-line' },
];

export const galleryImages = [
  {
    src: 'https://readdy.ai/api/search-image?query=Aerial%20drone%20photograph%20of%20a%20premium%20plotted%20land%20development%20with%20neatly%20arranged%20plot%20boundaries%2C%20wide%20paved%20internal%20roads%2C%20landscaped%20green%20medians%2C%20street%20lights%2C%20and%20lush%20surrounding%20vegetation%20in%20a%20gated%20township%20layout%2C%20cinematic%20daylight%2C%20high%20altitude%20perspective%2C%20warm%20golden%20hour%20lighting%2C%20shot%20from%20above%20showing%20organized%20grid%20pattern%20of%20empty%20land%20plots%20ready%20for%20construction&width=640&height=480&seq=1&orientation=landscape',
    alt: 'Aerial view of premium plots near Bangalore at Confident Auriga gated community plots in Malur',
    category: 'Aerial',
    span: 'col-span-2 row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Grand%20gated%20entrance%20of%20a%20premium%20plotted%20development%20township%20with%20stone%20pillars%2C%20iron%20gates%2C%20landscaped%20flower%20beds%2C%20paved%20driveway%2C%20warm%20evening%20lighting%2C%20architectural%20photography%2C%20modern%20Indian%20real%20estate%20development%20entrance%2C%20clean%20and%20organized%20layout&width=400&height=400&seq=2&orientation=squarish',
    alt: 'Grand gated entrance of Confident Auriga premium plotted development Bangalore',
    category: 'Entrance',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Premium%20clubhouse%20building%20exterior%20in%20a%20plotted%20development%20township%20with%20modern%20architecture%2C%20large%20glass%20windows%2C%20landscaped%20gardens%2C%20outdoor%20seating%20area%2C%20warm%20sunset%20lighting%2C%20Indian%20real%20estate%20project%20clubhouse%20render%20style%2C%20clean%20and%20luxurious%20aesthetic&width=400&height=400&seq=3&orientation=squarish',
    alt: 'Premium clubhouse at Confident Auriga villa plots in Malur with modern architecture',
    category: 'Clubhouse',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Wide%20tree-lined%20internal%20road%20inside%20a%20premium%20plotted%20development%20township%20with%20paved%20surface%2C%20street%20lamps%2C%20manicured%20green%20medians%2C%20rows%20of%20young%20trees%2C%20clean%20organized%20layout%2C%20aerial%20or%20ground%20perspective%2C%20warm%20daylight%2C%20Indian%20real%20estate%20development%20photography&width=400&height=500&seq=4&orientation=portrait',
    alt: 'Wide tree-lined internal road inside Confident Auriga gated community plots in Malur',
    category: 'Roads',
    span: 'col-span-1 row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Beautiful%20landscape%20garden%20and%20open%20green%20space%20in%20a%20premium%20plotted%20development%20with%20walking%20paths%2C%20flowering%20plants%2C%20benches%2C%20manicured%20lawns%2C%20peaceful%20environment%2C%20aerial%20perspective%2C%20warm%20golden%20hour%20lighting%2C%20Indian%20real%20estate%20township%20photography&width=600&height=400&seq=5&orientation=landscape',
    alt: 'Beautiful landscape gardens and green spaces at Confident Auriga investment plots near Bangalore',
    category: 'Gardens',
    span: 'col-span-2 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Children%20play%20area%20in%20a%20premium%20plotted%20development%20township%20with%20modern%20play%20equipment%2C%20rubberized%20flooring%2C%20colorful%20slides%20and%20swings%2C%20surrounded%20by%20green%20grass%20and%20trees%2C%20bright%20daylight%2C%20clean%20and%20safe%20environment%2C%20Indian%20real%20estate%20amenity%20photography&width=400&height=300&seq=6&orientation=landscape',
    alt: 'Children play area at Confident Auriga premium plotted development in Malur with safe modern equipment',
    category: 'Amenities',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Sunset%20aerial%20view%20of%20a%20premium%20plotted%20land%20development%20with%20empty%20green%20plots%20arranged%20in%20a%20grid%2C%20wide%20roads%2C%20surrounding%20trees%2C%20warm%20orange%20and%20gold%20sky%2C%20long%20shadows%2C%20cinematic%20real%20estate%20photography%2C%20peaceful%20and%20serene%20atmosphere%2C%20Indian%20township%20from%20above&width=400&height=300&seq=7&orientation=landscape',
    alt: 'Sunset aerial view of Confident Auriga land investment near Bangalore with organized green plots',
    category: 'Plots',
    span: 'col-span-1 row-span-1',
  },
];

export const locationAdvantages = [
  {
    title: 'Easy Access to Bangalore',
    description: 'Direct connectivity via Old Madras Road and NH-75. Reach Bangalore CBD in just 45 minutes from these premium plots near Bangalore.',
    icon: 'ri-car-line',
  },
  {
    title: 'Nearby Highways',
    description: 'Connected to NH-75, SH-96, and the upcoming satellite ring road for seamless plotted development Bangalore access.',
    icon: 'ri-road-map-line',
  },
  {
    title: 'Investment Growth Corridor',
    description: 'Designated growth zone with government incentives and major developments driving land investment near Bangalore.',
    icon: 'ri-arrow-up-line',
  },
];

export const investmentBenefits = [
  {
    title: 'High Appreciation Potential',
    description: 'Strategic location ensures consistent year-over-year value growth.',
    icon: 'ri-arrow-up-circle-line',
  },
  {
    title: 'Strategic Location',
    description: 'At the intersection of Bangalore growth axis and Malur industrial zone.',
    icon: 'ri-map-pin-2-line',
  },
  {
    title: 'Premium Community Living',
    description: 'Gated community with world-class amenities and aspirational lifestyle.',
    icon: 'ri-vip-crown-line',
  },
  {
    title: 'Long-Term Asset Value',
    description: 'Land is finite. Premium plotted development secures generational wealth.',
    icon: 'ri-safe-line',
  },
];

export const testimonials = [
  {
    name: 'Rajesh Krishnamurthy',
    role: 'IT Professional, Bangalore',
    review: 'I booked two plots at Confident Auriga after visiting the site. The location connectivity to Bangalore is excellent and the appreciation potential is clearly visible. This is one of the best investment plots near Bangalore for long-term investors.',
    rating: 5,
  },
  {
    name: 'Priya Natarajan',
    role: 'Business Owner, Chennai',
    review: 'After comparing multiple plotted developments near Bangalore, Auriga stood out for its planned infrastructure and gated community layout. The team was transparent and the process was seamless for acquiring villa plots in Malur.',
    rating: 5,
  },
  {
    name: 'Unicorn Creations',
    role: 'Investor, Bangalore',
    review: 'Malur is fast becoming Bangalore\'s next growth corridor. With strong connectivity to Whitefield and the CBD, this plotted development offers patient investors a promising land investment opportunity and long-term appreciation potential.',
    rating: 5,
  },
  {
    name: 'Sandeep Reddy',
    role: 'Business Owner, Bangalore',
    review: 'Malur has huge future potential and Confident Auriga feels like a well-planned long-term investment. The infrastructure planning and greenery inside the community really impressed me during the site visit. Highly recommended for premium plots near Bangalore.',
    rating: 5,
  },
  {
    name: 'Priya Sharma',
    role: 'Software Engineer, Whitefield',
    review: 'I was searching for plotted developments with strong appreciation potential and good connectivity. Auriga offered both as a premium gated community plots in Malur. The community layout and planned amenities make it stand out from other projects nearby.',
    rating: 5,
  },
  {
    name: 'Arvind Narayan',
    role: 'Investor, Bengaluru',
    review: 'The project gives a premium feeling while still being investment-friendly. Wide roads, green spaces, and future growth around Malur make this a smart decision for investors looking beyond Bangalore city for plotted development Bangalore opportunities.',
    rating: 5,
  },
];

export const footerLinks = {
  quickLinks: [
    { label: 'Home', href: '#hero' },
    { label: 'Overview', href: '#overview' },
    { label: 'Amenities', href: '#amenities' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Location', href: '#location' },
  ],
  resources: [
    { label: 'Master Plan', href: '#masterplan' },
    { label: 'Site Visit', href: 'https://wa.me/918861133745' },
    { label: 'Brochure', href: 'https://wa.me/918861133745' },
  ],
  contact: {
    phone: '+91 88611 33745',
    address: '4W46+8JM, Promenade Rd, Thornahalli, Karnataka 563130',
    whatsapp: 'https://wa.me/918861133745',
  },
};

export const navLinks = [
  { label: 'Overview', href: '#overview' },
  { label: 'Amenities', href: '#amenities' },
  { label: 'Location', href: '#location' },
  { label: 'Enquiry', href: '#enquiry' },
];